import React, { Component } from "react";
import {
  withStyles,
  Card,
  CardHeader,
  CardContent,
  TextField,
  CardActionArea,
  Button,
  Typography,
} from "@material-ui/core";
import Send from "@material-ui/icons/Send";
import { green, red } from "@material-ui/core/colors";
import { Input } from "antd";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    backgroundColor: "#3D2D70",
  },
  resize: {
    fontSize: 18,
  },
  resizeLable: {
    fontSize: 15,
    fontWeight: 400,
  },
  resize: {
    fontSize: 18,
  },
  resizeLable: {
    fontSize: 15,
    fontWeight: 400,
  },
  forgotCard: {
    width: 400,
    padding: "20px",
  },
  colorMessage: {
    color: red[300],
  },
});

class FormTwo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      otp: "",
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();

    this.props.setOtp(this.state.otp);
  };

  render() {
    let { classes } = this.props;
    return (
      <div className={classes.container}>
        <form onSubmit={this.onSubmit}>
          <Card className={classes.forgotCard}>
            <div align="center">
              <img
                src={`/logo512.png`}
                style={{ width: 80, marginBottom: 10 }}
              />

              <Typography variant="h4" style={{ color: "black" }} gutterBottom>
                Shishu Sarothi MIS
              </Typography>
            </div>
            <CardHeader title={<div align="center">Forgot Password</div>} />
            <CardContent>
              <div align="center">
                <Typography variant="body1" className={classes.colorMessage}>
                  {this.props.message}
                </Typography>

                <Input
                  autoFocus={true}
                  type="number"
                  name="otp"
                  value={this.state.otp}
                  onChange={this.handleChange}
                  size="large"
                  placeholder="Please enter the OTP"
                  required={true}
                />

                {/* <TextField
                                required
                                label="Please enter the OTP"
                                type="number"
                                name="otp"
                                value={this.state.otp}
                                onChange={this.handleChange}
                                margin="normal"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                    },
                                    required: true,
                                    min: 0
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.resizeLable
                                    }
                                }}
                            /> */}
              </div>
            </CardContent>

            <CardContent style={{ textAlign: "right" }}>
              <Button variant="contained" type="submit">
                Next <Send />
              </Button>
            </CardContent>


            <div style={{ textAlign: "center" }}>
              <a style={{ color: "blue" }} href="/login">
                <u>Go to login</u>
              </a>
            </div>
          </Card>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(FormTwo);
